export default __webpack_public_path__ + "static/media/BMSVNCKH-07B ĐXDTHĐT.1fbfee78.docx";